// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-phone[data-v-7b729306] {
  border-radius: 10px;
  overflow: hidden;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  -webkit-box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.5);
  box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.5);
}
.video-phone.fullscreen[data-v-7b729306] {
  border-radius: 10px;
}
.video-phone.fullscreen .top-panel[data-v-7b729306],
.video-phone.fullscreen .bottom-panel[data-v-7b729306] {
  border-radius: 0;
}
.video-phone .start-size[data-v-7b729306] {
  height: 500px;
}
.video-phone .body[data-v-7b729306] {
  margin: inherit;
  overflow: hidden;
  background-color: #333333;
  position: relative;
  height: 100%;
  width: 100%;
}
.video-phone .body .draggable[data-v-7b729306] {
  position: absolute;
  width: 100%;
  top: 60px;
  bottom: 70px;
  user-select: none;
}
.video-phone .body img[data-v-7b729306] {
  height: 100%;
  width: 100%;
}
.video-phone .body .topbar[data-v-7b729306] {
  position: absolute;
  top: 0;
  height: 60px;
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
  pointer-events: none;
}
.video-phone .body .bottombar[data-v-7b729306] {
  position: absolute;
  bottom: 0;
  height: 70px;
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
  pointer-events: none;
}
.video-phone .body .localVideo[data-v-7b729306] {
  position: absolute;
  z-index: 1100;
  height: 100px;
  transform: rotateY(180deg);
  border-radius: 5px;
}
.video-phone .body .panel-show[data-v-7b729306] {
  top: 65px;
  right: 5px;
  transition: 0.4s;
}
.video-phone .body .panel-hide[data-v-7b729306] {
  top: 5px;
  right: 5px;
  transition: 0.4s;
}
.video-phone .body video#remoteVideo[data-v-7b729306] {
  height: 100%;
  width: 100%;
  display: block;
}
.video-phone .body .top-panel[data-v-7b729306] {
  top: -69px;
  background: rgba(0, 0, 0, 0.2);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  height: 60px;
}
.video-phone .body .top-panel .top-btn[data-v-7b729306] {
  padding: 21px;
}
.video-phone .body .top-panel .top-btn i[data-v-7b729306] {
  font-weight: 400;
  cursor: pointer;
}
.video-phone .body .top-panel .top-btn .rotate-45[data-v-7b729306] {
  transform: rotate(-45deg);
  font-size: 16px;
}
.video-phone .body .top-panel .top-panel-info[data-v-7b729306] {
  text-align: center;
  height: 50px;
}
.video-phone .body .top-panel .top-panel-info .phone-name[data-v-7b729306] {
  display: block;
  color: #ffffff;
  font-size: 20px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.video-phone .body .top-panel .top-panel-info .phone-status[data-v-7b729306] {
  color: #d7d7d7;
  font-size: 16px;
  padding-top: 5px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
}
.video-phone .body .bottom-panel[data-v-7b729306] {
  bottom: -84px;
  background: rgba(0, 0, 0, 0.2);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  position: absolute;
  width: 100%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
}
.video-phone .body .bottom-panel .func-button[data-v-7b729306] {
  height: 50px;
  width: 50px;
  background-color: #efefef;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  opacity: 0.7;
}
.video-phone .body .bottom-panel .func-button i[data-v-7b729306] {
  color: #929292;
  font-size: 17px;
  font-weight: 400;
}
.video-phone .body .bottom-panel .func-button .func-button-i-active[data-v-7b729306] {
  color: #F5F5F5;
}
.video-phone .body .bottom-panel .func-button-active[data-v-7b729306] {
  background-color: #929292;
}
.video-phone .body .bottom-panel .phone-btn-cont[data-v-7b729306] {
  width: 60px;
  height: 60px;
  margin: 0px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-phone .body .bottom-panel .phone-btn-cont .phone-btn[data-v-7b729306] {
  display: flex;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  color: white;
  font-size: 27px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.video-phone .body .bottom-panel .phone-btn-cont .phone-btn i[data-v-7b729306] {
  font-weight: 100;
}
.video-phone .body .bottom-panel .phone-btn-cont .phone-btn .fa-rotate[data-v-7b729306] {
  transform: rotate(225deg);
}
.video-phone .body .bottom-panel .phone-btn-cont .phone-red-btn[data-v-7b729306] {
  background-color: #ED220C;
}
.video-phone .body .top-panel-show[data-v-7b729306] {
  top: 0px;
  transition: 0.4s;
}
.video-phone .body .bottom-panel-show[data-v-7b729306] {
  bottom: 0px;
  transition: 0.4s;
}
.video-phone .body .top-panel-hide[data-v-7b729306] {
  top: -69px;
  transition: 0.4s;
}
.video-phone .body .bottom-panel-hide[data-v-7b729306] {
  bottom: -84px;
  transition: 0.4s;
}
.video-phone .panel-hide-calls-selector[data-v-7b729306] {
  top: 5px;
  left: 5px;
  transition: 0.4s;
}
.video-phone .panel-show-calls-selector[data-v-7b729306] {
  top: 65px;
  left: 5px;
  transition: 0.4s;
}
#localAudio[data-v-7b729306] {
  position: absolute;
  z-index: -10;
  height: 0;
  width: 0;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/phone/PhoneWebrtcVideo.vue"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,uDAAuD;EACvD,oDAAoD;EACpD,+CAA+C;AACjD;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;AACA;EACE,UAAU;EACV,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,QAAQ;AACV","sourcesContent":[".video-phone[data-v-7b729306] {\n  border-radius: 10px;\n  overflow: hidden;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  -webkit-box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.5);\n  -moz-box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.5);\n  box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.5);\n}\n.video-phone.fullscreen[data-v-7b729306] {\n  border-radius: 10px;\n}\n.video-phone.fullscreen .top-panel[data-v-7b729306],\n.video-phone.fullscreen .bottom-panel[data-v-7b729306] {\n  border-radius: 0;\n}\n.video-phone .start-size[data-v-7b729306] {\n  height: 500px;\n}\n.video-phone .body[data-v-7b729306] {\n  margin: inherit;\n  overflow: hidden;\n  background-color: #333333;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.video-phone .body .draggable[data-v-7b729306] {\n  position: absolute;\n  width: 100%;\n  top: 60px;\n  bottom: 70px;\n  user-select: none;\n}\n.video-phone .body img[data-v-7b729306] {\n  height: 100%;\n  width: 100%;\n}\n.video-phone .body .topbar[data-v-7b729306] {\n  position: absolute;\n  top: 0;\n  height: 60px;\n  width: 100%;\n  user-select: none;\n  -webkit-user-select: none;\n  pointer-events: none;\n}\n.video-phone .body .bottombar[data-v-7b729306] {\n  position: absolute;\n  bottom: 0;\n  height: 70px;\n  width: 100%;\n  user-select: none;\n  -webkit-user-select: none;\n  pointer-events: none;\n}\n.video-phone .body .localVideo[data-v-7b729306] {\n  position: absolute;\n  z-index: 1100;\n  height: 100px;\n  transform: rotateY(180deg);\n  border-radius: 5px;\n}\n.video-phone .body .panel-show[data-v-7b729306] {\n  top: 65px;\n  right: 5px;\n  transition: 0.4s;\n}\n.video-phone .body .panel-hide[data-v-7b729306] {\n  top: 5px;\n  right: 5px;\n  transition: 0.4s;\n}\n.video-phone .body video#remoteVideo[data-v-7b729306] {\n  height: 100%;\n  width: 100%;\n  display: block;\n}\n.video-phone .body .top-panel[data-v-7b729306] {\n  top: -69px;\n  background: rgba(0, 0, 0, 0.2);\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  width: 100%;\n  position: absolute;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #ffffff;\n  height: 60px;\n}\n.video-phone .body .top-panel .top-btn[data-v-7b729306] {\n  padding: 21px;\n}\n.video-phone .body .top-panel .top-btn i[data-v-7b729306] {\n  font-weight: 400;\n  cursor: pointer;\n}\n.video-phone .body .top-panel .top-btn .rotate-45[data-v-7b729306] {\n  transform: rotate(-45deg);\n  font-size: 16px;\n}\n.video-phone .body .top-panel .top-panel-info[data-v-7b729306] {\n  text-align: center;\n  height: 50px;\n}\n.video-phone .body .top-panel .top-panel-info .phone-name[data-v-7b729306] {\n  display: block;\n  color: #ffffff;\n  font-size: 20px;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.video-phone .body .top-panel .top-panel-info .phone-status[data-v-7b729306] {\n  color: #d7d7d7;\n  font-size: 16px;\n  padding-top: 5px;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n}\n.video-phone .body .bottom-panel[data-v-7b729306] {\n  bottom: -84px;\n  background: rgba(0, 0, 0, 0.2);\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  position: absolute;\n  width: 100%;\n  color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 70px;\n}\n.video-phone .body .bottom-panel .func-button[data-v-7b729306] {\n  height: 50px;\n  width: 50px;\n  background-color: #efefef;\n  border-radius: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  opacity: 0.7;\n}\n.video-phone .body .bottom-panel .func-button i[data-v-7b729306] {\n  color: #929292;\n  font-size: 17px;\n  font-weight: 400;\n}\n.video-phone .body .bottom-panel .func-button .func-button-i-active[data-v-7b729306] {\n  color: #F5F5F5;\n}\n.video-phone .body .bottom-panel .func-button-active[data-v-7b729306] {\n  background-color: #929292;\n}\n.video-phone .body .bottom-panel .phone-btn-cont[data-v-7b729306] {\n  width: 60px;\n  height: 60px;\n  margin: 0px 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.video-phone .body .bottom-panel .phone-btn-cont .phone-btn[data-v-7b729306] {\n  display: flex;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  color: white;\n  font-size: 27px;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n}\n.video-phone .body .bottom-panel .phone-btn-cont .phone-btn i[data-v-7b729306] {\n  font-weight: 100;\n}\n.video-phone .body .bottom-panel .phone-btn-cont .phone-btn .fa-rotate[data-v-7b729306] {\n  transform: rotate(225deg);\n}\n.video-phone .body .bottom-panel .phone-btn-cont .phone-red-btn[data-v-7b729306] {\n  background-color: #ED220C;\n}\n.video-phone .body .top-panel-show[data-v-7b729306] {\n  top: 0px;\n  transition: 0.4s;\n}\n.video-phone .body .bottom-panel-show[data-v-7b729306] {\n  bottom: 0px;\n  transition: 0.4s;\n}\n.video-phone .body .top-panel-hide[data-v-7b729306] {\n  top: -69px;\n  transition: 0.4s;\n}\n.video-phone .body .bottom-panel-hide[data-v-7b729306] {\n  bottom: -84px;\n  transition: 0.4s;\n}\n.video-phone .panel-hide-calls-selector[data-v-7b729306] {\n  top: 5px;\n  left: 5px;\n  transition: 0.4s;\n}\n.video-phone .panel-show-calls-selector[data-v-7b729306] {\n  top: 65px;\n  left: 5px;\n  transition: 0.4s;\n}\n#localAudio[data-v-7b729306] {\n  position: absolute;\n  z-index: -10;\n  height: 0;\n  width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
